import { createSlice } from "@reduxjs/toolkit";

const colors = [
  "#BB2436",
  "#503bc1",
  "#E56B1F",
  "#34bd7b",
  "#0077b6",
  "#d27b78",
  "#807050",
  "#c70039",
  "#e5b808",
  "#902bf8",
];
const mode = ["light", "dark"];
const DEFAULT_MAIN_COLOR = colors[0];

function normalizeThemeColor(value) {
  if (typeof value === "string" && value.startsWith("#") && value.length >= 4) {
    return value;
  }
  return null;
}

const storedMainColor = localStorage.getItem("mainColor");
const initialState = {
  colors: colors,
  mode: localStorage.getItem("mode") ? localStorage.getItem("mode") : mode[0],
  originalMode: localStorage.getItem("mode")
    ? localStorage.getItem("mode") === "auto"
      ? mode[0]
      : localStorage.getItem("mode")
    : mode[0],
  mainColor: normalizeThemeColor(storedMainColor) ?? DEFAULT_MAIN_COLOR,
  autoValue: null,
  direction: localStorage.getItem("i18nextLng")?.startsWith("ar")
    ? "rtl"
    : "ltr",
  isChangingDirection:false
};

const themeSlice = createSlice({
  name: "themeValues",
  initialState,
  reducers: {
    apply(state, action) {
      const nextMainColor = normalizeThemeColor(action.payload?.mainColor) ?? state.mainColor;
      const nextMode = action.payload?.mode ?? state.mode;
      state.mainColor = nextMainColor;
      state.mode = nextMode;
      state.originalMode =
        nextMode === "auto" ? state.autoValue : nextMode;
      localStorage.setItem("mode", nextMode);
      localStorage.setItem("mainColor", nextMainColor);
    },
    setDirection(state, action) {
      state.direction = action.payload.directionValue;
    },
    changingDirection(state, action) {
      state.isChangingDirection = action.payload.value;
    },
    setAutoValue(state, action) {
      state.autoValue = action.payload.autoValue;
      const currentMode =
        state.mode === "auto" ? action.payload.autoValue : state.mode;
      state.originalMode = currentMode;
    },
    resetPalette(state, action) {
      state.mainColor = colors[0];
      state.mode = mode[0];
      state.originalMode =
        mode[0] === "auto" ? state.autoValue : mode[0];
      localStorage.setItem("mode", mode[0]);
      localStorage.setItem("mainColor", colors[0]);
    },
  },
});

export const { apply, setAutoValue, setDirection,changingDirection, resetPalette } = themeSlice.actions;
export default themeSlice.reducer;
